import request from '../utils/request'

export function login(user_name, password) {
    return request({
        url: '/api/auth/login',
        method: 'post',
        data: {
            user_name, password
        }
    })
}

export function getUserInfo(userToken) {
    return request({
        url: '/api/user/info',
        method: 'get',
        params: {
            user_token: userToken
        }
    })
}